const user = {
    state: {
        token: '', // 令牌信息
        name: '', // 用户名称
        // avatar: '',
        role: null, // 角色信息
    },
    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token;
            LYCom.SetToken(token);
            // sessionStorage.setItem("token", token);
            // sessionStorage.setItem("token", token);
        },
        SET_NAME: (state, name) => {
            state.name = name
        },
        // SET_AVATAR: (state, avatar) => {
        //     state.avatar = avatar
        // },
        SET_ROLE: (state, role) => {
            state.role = role
        }
    },
    actions: {
        //     // 登录
        //     Login({ commit }, userInfo) {
        //         const username = userInfo.username.trim()
        //         return new Promise((resolve, reject) => {
        //             login(username, userInfo.password).then(response => {
        //                 const data = response.data
        //                 const tokenStr = data.tokenHead+data.token
        //                 setToken(tokenStr)
        //                 commit('SET_TOKEN', tokenStr)
        //                 resolve()
        //             }).catch(error => {
        //                 reject(error)
        //             })
        //         })
        //     },
        //
        // 获取用户信息
        GetInfo({ commit, state }) {
            return new Promise((resolve, reject) => {
                // getInfo().then(response => {
                //     const data = response.data
                //     if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
                //         commit('SET_ROLES', data.roles)
                //     } else {
                //         reject('getInfo: roles must be a non-null array !')
                //     }
                //     commit('SET_NAME', data.username)
                //     commit('SET_AVATAR', data.icon)
                //     resolve(response)
                // }).catch(error => {
                //     reject(error)
                // })
                try {
                    let data = LYCom.CallBiz("SysMgrBiz", "GetUserInfo", sessionStorage.getItem("token"));
                    if (data != null) {
                        commit("SET_NAME", data.display_name);
                        commit('SET_ROLE', {
                            "role_id": data.role_id,
                            "role_name": data.role_name,
                            "role_group": data.role_group
                        });
                    }

                    resolve(data);
                } catch (e) {
                    reject(e);
                }
            })
        },
        /**
         * 登出
         * @param commit
         * @param state
         * @returns {Promise<any>}
         * @constructor
         */
        LogOut({ commit, state }) {
            return new Promise((resolve, reject) => {
                let rtn = LYCom.CallBiz("SysMgrBiz", "LoginOut", LYCom.GetToken());
                if (rtn) {
                    commit('SET_TOKEN', '');
                    commit('SET_ROLE', null);
                    LYCom.RemoveToken();
                    resolve();
                }
            });
        },

        /**
         * 前端 登出
         * @param commit
         * @returns {Promise<any>}
         * @constructor
         */
        FedLogOut({ commit }) {
            return new Promise(resolve => {
                commit('SET_TOKEN', '')
                LYCom.RemoveToken();
                resolve()
            })
        }
    }
}

export default user


// WEBPACK FOOTER //
// ./src/store/modules/user.js